import {Component, Input, OnInit} from '@angular/core';
import {DataGridService} from '../data-grid.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
    selector: 'vui-data-grid-query',
    templateUrl: './data-grid-query.component.html',
    styleUrls: ['./data-grid-query.component.scss']
})
export class DataGridQueryComponent implements OnInit {
    public formGroup: FormGroup;
    @Input() public placeholder: string;

    constructor(private dataGridService: DataGridService) {
        this.formGroup = new FormGroup({
            query: new FormControl('')
        });
    }

    public ngOnInit(): void {
        this.formGroup.valueChanges.subscribe((valueChange) => {
            this.dataGridService.query$.next(valueChange.query);
        });
    }
}
